export enum TeamRoles {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}

export enum RolesScope {
  TEAM = 'TEAM',
}
